import * as React from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import {useNavigate} from "react-router-dom";
import api from "../services/api";
import logo from '../assets/logo.jpg'
import {useEffect, useState} from "react";

export default function SignIn() {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const token = localStorage.getItem('token')
        if (token) {
            api().games().then(games => {
                const startedGame = games.find(game => !!game.started_at && !game.ended_at)
                if (startedGame) {
                    navigate('/play/' + startedGame.id)
                }
            })
        }
    }, [navigate])

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        setLoading(true)

        api().login({
            email: data.get('email'),
            password: 'nopassword'
        })
            .then(response => localStorage.setItem('token', response.token))
            .then(() => api().players())
            .then(players => localStorage.setItem('player', players[0].id))
            .then(() => navigate('adventures'))
            .catch(error => console.log(error))
            .finally(() => setLoading(false))
    };

    return (
        <>
            <img src={logo} alt={'logo'} width={400}/>
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Adresse Email"
                    name="email"
                    autoComplete="email"
                    autoFocus
                />
                <LoadingButton
                    loading={loading}
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                >
                    Commencer l'aventure
                </LoadingButton>
            </Box>
        </>
    );
}
